/* import __COLOCATED_TEMPLATE__ from './unlink.hbs.js'; */
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import SvgIcon from '@square/glass-ui/components/svg/svg-icon';
export default class Unlink extends SvgIcon {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "height", '24');
    _defineProperty(this, "width", '24');
    _defineProperty(this, "viewBox", '0 0 24 22');
    _defineProperty(this, "title", '');
  }
}